import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import { memo } from 'react';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryLotNumber,
    getItemSummaryTitle,
    getItemSummaryUrl,
} from '@/redux/modules/item/summary/itemSummary.selectors';

type Props = {
    hideLotNumbers?: boolean;
    itemId: number;
    openOnBlank?: boolean;
};

const TitleRowComponent = ({ hideLotNumbers, itemId, openOnBlank }: Props) => {
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));
    const itemUrl = useAppSelector((state) => getItemSummaryUrl(state, itemId));

    const lotNumberDisplay = lotNumber ? <span>{lotNumber}:&nbsp; </span> : <span>&nbsp; 0000</span>;

    const titleContent = (
        <>
            {!hideLotNumbers && lotNumberDisplay}
            {title}
        </>
    );

    return (
        <div className="relative mb-3xs block min-h-[48px] overflow-visible text-text-primary mobile:min-h-[40px]">
            {title ? (
                <H4
                    as="span"
                    className="static inline-block whitespace-normal break-words font-secondary capitalize tracking-[0.5px] mobile:text-[13px] mobile:leading-[18px] [&_span:first-of-type]:font-secondary"
                >
                    {openOnBlank ? (
                        <Link
                            className="line-clamp-2"
                            data-testid="itemTitleText"
                            href={itemUrl}
                            target="_blank"
                        >
                            {titleContent}
                        </Link>
                    ) : (
                        <RouteLink
                            className="line-clamp-2"
                            data-testid="itemTitleText"
                            to={itemUrl}
                        >
                            {titleContent}
                        </RouteLink>
                    )}
                </H4>
            ) : (
                <H4
                    as="span"
                    className="static inline-block whitespace-normal break-words font-secondary capitalize tracking-[0.5px] mobile:text-[13px] mobile:leading-[18px] [&_span:first-of-type]:font-secondary"
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </H4>
            )}
        </div>
    );
};

export const TitleRow = memo<Props>(TitleRowComponent);
